import React, { useState, useEffect } from "react";

const slides = [
  {
    id: 1,
    text: "STAFFING SERVICES",
    description:
      "Our Company matches the right person with the Right Job we help companies secure the talent they need to be Successful . PSR-IT staffing services spans globally as well as across various skill sets. We have a dedicated team for executive level placements as well",
    background: "/images/background_2.jpg",
  },
  {
    id: 2,
    text: "Recruitment Processing Outsourcing (RPO)",
    description:
      "Today, hiring is more than simply blasting out a jobs list and waiting for resumes to fall in. It requires an inordinate amount of time and expense to identify, interview, and hire the best candidates for the job. Much of this time is spent on administrative tasks, leaving managers to rush through candidate interaction.",
    background: "/images/background_3.jpg",
  },
  {
    id: 3,
    text: "Business Processing Outsourcing (BPO)",
    description:
      "PSR-IT BPO focuses on all kinds of Desk Top support services primarily in relation to customer organization. Our philosophy of delving deep into the customer’s business",
    background: "/images/background_4.jpg",
  },
  {
    id: 4,
    text: "IT SERVICES",
    description:
      "At Corporate Technologies, we understand that IT issues have the ability to bring businesses to a screeching halt. Our managed services and business IT solutions allow you to focus on business rather than reacting to problems when they arise. we have helped businesses of all sizes.we are confident we can develop a custom solution to meet any company’s unique needs",
    background: "/images/background_5.jpg",
  },
];

const Banner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); 

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      id="heroCarousel"
      className="carousel slide carousel-fade"
      data-bs-ride="carousel"
      style={{ height: "100vh", overflow: "hidden", marginBottom: "50px" }}
    >
      <div className="carousel-inner" style={{ height: "100%" }}>
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`carousel-item ${index === currentSlide ? "active" : ""}`}
            style={{
              height: "100%",
              transition: "opacity 1s ease-in-out",
            }}
          >
            <img
              src={slide.background}
              className="d-block w-100"
              alt={slide.text}
              style={{
                height: "120%",
                objectFit: "cover",
                transition: "transform 1s ease-in-out",
              }}
            />
            <div className="carousel-caption d-none d-md-block text-white bg-black bg-opacity-50 p-4">
              <h5>{slide.text}</h5>
              <p>{slide.description}</p>
            </div>
          </div>
        ))}
      </div>

      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#heroCarousel"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#heroCarousel"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
      </button>
    </div>
  );
};

export default Banner;
